import { render, staticRenderFns } from "./IntegrationVariable.vue?vue&type=template&id=61061418&scoped=true"
import script from "./IntegrationVariable.vue?vue&type=script&lang=js"
export * from "./IntegrationVariable.vue?vue&type=script&lang=js"
import style0 from "./IntegrationVariable.vue?vue&type=style&index=0&id=61061418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61061418",
  null
  
)

export default component.exports